function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-338.612,393.905l-12.025-10.939a1.787,1.787,0,0,0-2.4,0l-12.025,10.939a1.778,1.778,0,0,0-.113,2.51h0a1.808,1.808,0,0,0,1.318.579,1.77,1.77,0,0,0,1.205-.466l10.813-9.848,10.82,9.848a1.787,1.787,0,0,0,2.517-.113,1.772,1.772,0,0,0-.107-2.51Z",
  transform: "translate(365.643 -382.501)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-345.442,396.784-355,405.446v11.133a.951.951,0,0,0,.481.831,1.423,1.423,0,0,0,.734.212h16.519a1.747,1.747,0,0,0,.821-.212,1.019,1.019,0,0,0,.568-.831V405.446Zm3.868,15.142h-7.73v-5.289h7.73Z",
  transform: "translate(359.33 -390.973)",
  fill: "#fff"
})));

var SvgHomeIcon = function SvgHomeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.608,
    height: 26.649,
    viewBox: "0 0 27.608 26.649",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/homeIcon.71de17ea.svg";
export { ForwardRef as ReactComponent };